var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({class:{'slo-icon': true, [`size-${_vm.size}`]: _vm.size !== 'base'}},'div',_vm.$attrs,false),_vm.$listeners),[_c(_vm.name,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }